window.tooltip = (() => {
  if (typeof $ != 'undefined' && typeof $('[data-toggle="tooltip"]').tooltip != 'undefined') {
    $('[data-toggle="tooltip"]').tooltip().each(function () {
      var rendered = $(this).data('tooltip-rendered');
      if (!rendered) {
        $('[data-toggle="tooltip"]').tooltip({
          html: true
        });
        $(this).data('tooltip-rendered', true);
      }
    });
  }
  // if (typeof $('[data-toggle="tooltip"]').tooltip != 'undefined') {
  //   return $('[data-toggle="tooltip"]').tooltip({
  //     html: true
  //   });
  // }
});

// $('[data-toggle="tooltip"]').tooltip('hide')
// $('.ui-tooltip').hide();

// $(() => {
//   // Mutator
//   setInterval(tooltip, 2000);
// });